"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/DataEntryModeToggle.css");
var DataEntryModeToggle = /** @class */ (function (_super) {
    __extends(DataEntryModeToggle, _super);
    function DataEntryModeToggle(props) {
        var _this = _super.call(this, props) || this;
        _this.self = React.createRef();
        return _this;
    }
    DataEntryModeToggle.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, { className: "DataEntryModeToggle" },
            React.createElement(reactstrap_1.Col, null),
            React.createElement(reactstrap_1.Col, { md: "auto", className: "pr-1" }, this.props.resources.ScannerInput),
            React.createElement(reactstrap_1.Col, { md: "auto", className: "pl-1" },
                React.createElement(reactstrap_1.CustomInput, { type: "switch", id: "exampleCustomSwitch", name: "customSwitch", label: this.props.resources.ManualInput, innerRef: this.self, onChange: function () { var _a; _this.props.onChange(); (_a = _this.self.current) === null || _a === void 0 ? void 0 : _a.blur(); }, checked: this.props.manualEntry }))));
    };
    return DataEntryModeToggle;
}(React.Component));
exports.DataEntryModeToggle = DataEntryModeToggle;
//# sourceMappingURL=DataEntryModeToggle.js.map